import { isDate } from 'date-fns'

const isValidDate = (date) => date instanceof Date && !isNaN(date)

export const toDateObject = (value) =>
  isDate(value) ? value : isValidDate(new Date(value)) ? new Date(value) : undefined
